import { Box } from '@mui/material';
import { FunctionComponent } from 'react';

interface DocCodeProps {
    children: string;
}

/**
 * Monospace block for a snippet or a literal attribute name.
 *
 * Shared by `WidgetDocSection` (per-widget script tag / step snippets) and
 * `WidgetDocsDialog` (general-section code samples) so the two never drift
 * into slightly different `<pre>` styling.
 */
export const DocCode: FunctionComponent<DocCodeProps> = ({ children }) => (
    <Box
        component='pre'
        sx={{
            m: 0,
            mt: 1,
            p: 2,
            overflowX: 'auto',
            fontFamily: 'monospace',
            fontSize: 13,
            whiteSpace: 'pre',
            bgcolor: 'grey.50',
        }}
    >
        {children}
    </Box>
);
